class VariantOptions extends HTMLElement {
    constructor() {
        super();
        this.buttons = Array.from(this.querySelectorAll('button[option]'));
        this.allVariantButtons = Array.from(document.querySelectorAll('button.variant'));
        this.buttons.forEach(button => {
            if (button.classList.contains('-selected') && button.getAttribute('option') === 'option1') {
                this.option1Selected = button;
            }
            if (button.classList.contains('-selected') && button.getAttribute('option') === 'option2') {
                this.option2Selected = button;
            }
            if (button.classList.contains('-selected') && button.getAttribute('option') === 'option3') {
                this.option3Selected = button;
            }
            button.addEventListener('click', this.onOptionChange.bind(this));
        });
    }
    onOptionChange(e) {
        const target = e.target;
        const button = target.closest('button');
        const name = document.getElementById('option-name');
        if (!button?.hasAttribute('option'))
            return;
        if (name) {
            name.innerHTML = button.getAttribute('value');
        }
        if (button.getAttribute('option') === 'option1') {
            this.option1Selected.classList.remove('-selected');
            this.option1Selected = button;
        }
        if (button.getAttribute('option') === 'option2') {
            this.option2Selected.classList.remove('-selected');
            this.option2Selected = button;
        }
        if (button.getAttribute('option') === 'option3') {
            this.option3Selected.classList.remove('-selected');
            this.option3Selected = button;
        }
        if (button.getAttribute('variant-id')) {
            const selectedVariantId = button.getAttribute('variant-id');
            const quantityElement = document.getElementById("variant-quantity");
            // Envía una solicitud AJAX al servidor para obtener la cantidad en el carrito para la variante seleccionada
            fetch(`/cart.js`)
                .then(response => response.json())
                .then(cart => {
                const cartItem = cart.items.find(item => item.variant_id == selectedVariantId);
                const quantity = cartItem ? cartItem.quantity : 0;
                if (quantity > 0)
                    quantityElement.textContent = '(' + quantity + ' en el carrito)';
                else
                    quantityElement.textContent = '';
            });
        }
        button.classList.add('-selected');
        const options = {
            option1: this.option1Selected?.getAttribute('value'),
            option2: this.option2Selected?.getAttribute('value'),
            option3: this.option3Selected?.getAttribute('value'),
        };
        for (const button of this.allVariantButtons) {
            const isSameOption1 = options.option1 ? button.getAttribute('option1') === options.option1 : true;
            const isSameOption2 = options.option2 ? button.getAttribute('option2') === options.option2 : true;
            const isSameOption3 = options.option3 ? button.getAttribute('option3') === options.option3 : true;
            if (isSameOption1 && isSameOption2 && isSameOption3) {
                button.click();
                break;
            }
        }
    }
}
customElements.define('variant-options', VariantOptions);
